import script from "./Avatar.vue?vue&type=script&lang=ts&setup=true"
export * from "./Avatar.vue?vue&type=script&lang=ts&setup=true"

import "./Avatar.vue?vue&type=style&index=0&id=b93e570c&lang=css"

const __exports__ = script;

export default __exports__